<section>
  <div class="d-flex justify-content-end mb-3 px-2 mb-xl-4">
    <app-form-modal-img-laudo [elements]="modalElements" (saveEvent)="getMultiplasFotos($event)"></app-form-modal-img-laudo>
  </div>

  <app-template-builder [children]="template" [elements]="elements"></app-template-builder>

  <div class="px-1 px-xl-2 mb-4 mb-lg-5 "><app-form-img-adicional-laudo [formId]="formId"></app-form-img-adicional-laudo></div>

</section>